export const routeCreateRoute = `mutation RouteCreateRoute($input: RouteCreateRouteInput!) {
  routeCreateRoute(input: $input) {
    success
    message
  }
}
`;

export const routerStartEvent = `mutation RouterStartEvent($eventId: ID!) {
  routerStartEvent(eventId: $eventId) {
    success
    message
  }
}
`;

export const routerStopEvent = `mutation RouterStopEvent($eventId: ID!, $forceStop: Boolean) {
  routerStopEvent(eventId: $eventId, forceStop: $forceStop) {
    success
    message
  }
}
`;

export const routerRestartEvent = `mutation RouterRestartEvent($eventId: ID!) {
  routerRestartEvent(eventId: $eventId) {
    success
    message
  }
}
`;

export const routerStopOutput = `mutation RouterStopOutput($eventId: ID!) {
  routerStopOutput(eventId: $eventId) {
    success
    message
  }
}
`;

export const routerStartTarget = `mutation RouterStartTarget($eventId: ID!, $targetId: ID!) {
  routerStartTarget(eventId: $eventId, targetId: $targetId) {
    success
    message
  }
}
`;

export const routerStopTarget = `mutation RouterStopTarget($eventId: ID!, $targetId: ID!) {
  routerStopTarget(eventId: $eventId, targetId: $targetId) {
    success
    message
  }
}
`;

export const routerSetStreamKey = `mutation RouterSetStreamKey($eventId: ID!, $targetId: ID!, $streamKey: String!) {
  routerSetStreamKey(eventId: $eventId, targetId: $targetId, streamKey: $streamKey) {
    success
    message
  }
}
`;

// Manual Routing Mutations
export const routerRoute = `mutation RouterRoute($inputId: ID!, $outputId: ID!, $audioPid: String, $videoPid: String, $streamKey: String) {
  routerRoute(inputId: $inputId, outputId: $outputId, audioPid: $audioPid, videoPid: $videoPid, streamKey: $streamKey) {
    success
    message
  }
}
`;

// OTT Output Routing
export const routerRouteSetStreamKey = `mutation RouterRouteSetStreamKey($outputId: ID!, $streamKey: String!) {
  routerRouteSetStreamKey(outputId: $outputId, streamKey: $streamKey) {
    success
    message
  }
}
`;

export const routerRouteStartTarget = `mutation RouterRouteStartTarget($outputId: ID!) {
  routerRouteStartTarget(outputId: $outputId) {
    success
    message
  }
}
`;

export const routerRouteStopTarget = `mutation RouterRouteStopTarget($outputId: ID!) {
  routerRouteStopTarget(outputId: $outputId) {
    success
    message
  }
}
`;

export const routerRouteRestartApplication = `mutation RouterRouteRestartApplication($outputId: ID!) {
  routerRouteRestartApplication(outputId: $outputId) {
    success
    message
  }
}
`;

// Stream Router Interface Routing
export const routerRouteStartInterface = `mutation RouterRouteStartInterface($outputId: ID!) {
  routerRouteStartInterface(outputId: $outputId) {
    success
    message
  }
}
`;

export const routerRouteStopInterface = `mutation RouterRouteStopInterface($outputId: ID!) {
  routerRouteStopInterface(outputId: $outputId) {
    success
    message
  }
}
`;

// Input Operations
export const routerRouteRestartEncoder = `mutation RouterRouteRestartEncoder($inputId: ID!) {
  routerRouteRestartEncoder(inputId: $inputId) {
    success
    message
  }
}
`;



export const routerStopInput = `mutation RouterStopInput($inputId: ID!) {
  routerStopInput(inputId: $inputId) {
    success
    message
  }
}
`;

// Route Disconnection
export const routerRouteOut = `mutation RouterRouteOut($inputId: ID, $outputId: ID) {
  routerRouteOut(inputId: $inputId, outputId: $outputId) {
    success
    message
  }
}
`;

// Output Status Queries
export const routerEventOutputTargetStatus = `query RouterEventOutputTargetStatus($eventId: ID!) {
  routerEventOutputTargetStatus(eventId: $eventId) {
    success
    message
    dataJson
  }
}
`;

export const routerOutputTargetStatus = `query RouterOutputTargetStatus($outputId: ID!) {
  routerOutputTargetStatus(outputId: $outputId) {
    success
    message
    dataJson
  }
}
`;

export const routerOutputsTargetStatus = `query RouterOutputsTargetStatus($outputIds: [ID!]!) {
  routerOutputsTargetStatus(outputIds: $outputIds) {
    success
    message
    dataJson
  }
}
`;

export const routerEventOutputsTargetStatus = `query RouterEventOutputsTargetStatus($eventIds: [ID!]!) {
  routerEventOutputsTargetStatus(eventIds: $eventIds) {
    success
    message
    dataJson
  }
}
`;

export const routerStartInput = `mutation RouterStartInput($inputId: ID!) {
  routerStartInput(inputId: $inputId) {
    success
    message
    dataJson
  }
}
`;
export const createMediaConnectInput = `mutation CreateMediaConnectInput($config: String!) {
  createMediaConnectInput(config: $config) {
    success
    message
    dataJson
  }
}
`;

export const updateMediaConnectInput = `mutation UpdateMediaConnectInput($config: String!) {
  updateMediaConnectInput(config: $config) {
    success
    message
    dataJson
  }
}
`;

export const createMediaConnectOutput = `mutation CreateMediaConnectOutput($config: String!) {
  createMediaConnectOutput(config: $config) {
    success
    message
    dataJson
  }
}
`;

export const updateMediaConnectOutput = `mutation UpdateMediaConnectOutput($config: String!) {
  updateMediaConnectOutput(config: $config) {
    success
    message
    dataJson
  }
}
`;


